import { Component, OnInit } from '@angular/core';
import { UpdateService } from './services/update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  title: string = 'salmon-elog';

  constructor(public updateService: UpdateService) {
    
  }

  ngOnInit(): void {
    this.updateService.CheckForUpdates(false);
  }

}
